import Vue from 'vue'
import Vuex from 'vuex'
import { cities } from "@/utils";
import modules from "./modules";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    schools: [],
    editSchool: {}
  },
  getters: {
    getCityById: (state) => (id) => {
      return cities.find((city) => city.id == id.toString)
    },
    schoolsByCity: (state) => (cityId) => {
      return state.schools
        .filter((obj) => obj.city === cityId.toString())
    }
  },
  mutations: {
    setEditSchool(state, school) {
      state.editSchool = school
    },
    updateSchool(state, school) {
      let objIndex = state.schools.findIndex((obj => obj._id == school._id));
      state.schools[objIndex] = school
    },
  },
  actions: {
  },
  modules: modules
})
